import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink],
  template: `
    <section class="not-found-card">
      <h1>Page not found</h1>
      <p>The requested page does not exist in the TOPS offline app.</p>
      <a class="btn primary" routerLink="/">Back to Jobs</a>
    </section>
  `,
  styles: [`
    .not-found-card {
      background: #fff;
      border: 1px solid #dbe3e1;
      border-radius: 8px;
      padding: 40px;
      text-align: center;
    }
  `],
})
export class NotFoundComponent {}
